<div class="grid grid--gap-8 grid--va-middle mt-24">
  <div class="grid__box grid__box--size-min">
    <div class="grid grid--va-middle">
      <div class="grid__box grid__box--size-min">
        <span class="title">Сотрудники</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--gap-8">
          <div class="grid__box grid__box--size-min">
            <div *ngIf="filter.data && filter.data.employers && filter.data.employers.working === 0">
              <span class="color-blue-dark"> На смене (0) </span>
            </div>
            <div *ngIf="filter.data && filter.data.employers && filter.data.employers.working > 0">
              <span class="color-blue-dark font-weight-bold" *ngIf="filter.filterType === 'working'">
                На смене ({{ filter.data && filter.data.employers && filter.data.employers.working }})
              </span>
              <a class="link link--dotted-blue-dark" (click)="filter.onSetFilter('working')" *ngIf="filter.filterType !== 'working'">
                На смене ({{ filter.data && filter.data.employers && filter.data.employers.working }})
              </a>
            </div>
          </div>
          <div class="grid__box grid__box--size-min">
            <div *ngIf="filter.data && filter.data.employers && filter.data.employers.action_required === 0">
              <span class="color-red-dark"> Требуют действий (0) </span>
            </div>
            <div *ngIf="filter.data && filter.data.employers && filter.data.employers.action_required > 0">
              <span class="color-red-dark font-weight-bold" *ngIf="filter.filterType === 'action_required'">
                Требуют действий ({{ filter.data && filter.data.employers && filter.data.employers.action_required }})
              </span>
              <a class="link link--dotted-red-dark" (click)="filter.onSetFilter('action_required')" *ngIf="filter.filterType !== 'action_required'">
                Требуют действий ({{ filter.data && filter.data.employers && filter.data.employers.action_required }})
              </a>
            </div>
          </div>
          <div class="grid__box grid__box--size-min">
            <div *ngIf="filter.data && filter.data.employers && filter.data.employers.all === 0">
              <span class="color-blue-dark"> Все (0) </span>
            </div>
            <div *ngIf="filter.data && filter.data.employers && filter.data.employers.all > 0">
              <span class="color-blue-dark font-weight-bold" *ngIf="filter.filterType === 'all'">
                Все ({{ filter.data && filter.data.employers && filter.data.employers.all }})
              </span>
              <a class="link link--dotted-blue-dark" (click)="filter.onSetFilter('all')" *ngIf="filter.filterType !== 'all'">
                Все ({{ filter.data && filter.data.employers && filter.data.employers.all }})
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="vertical-separate"></div>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="title">Бригады</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <span
          class="color-blue-dark"
          [ngClass]="{
            'color-blue-dark': filter.data && filter.data.brigades && !filter.data.brigades.length,
            'color-red-dark': filter.data && filter.data.brigades && filter.data.brigades.length
          }"
        >
          Требуют действий ({{ filter.data && filter.data.tickets && filter.data.tickets.all }})
        </span>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="vertical-separate"></div>
      </div>
      <div class="grid__box grid__box--size-min">
        <span *ngIf = "isDispatcher" class="title">Заявки</span>
        <span *ngIf = "!isDispatcher" class="title">Выезды</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="grid grid--gap-8">
          <div class="grid__box grid__box--size-min">
            <span class="color-blue-dark"> Назначено ({{ filter.data && filter.data.tickets && filter.data.tickets.assigned }}) </span>
          </div>
          <div class="grid__box grid__box--size-min">
            <span
              class="color-blue-dark"
              [ngClass]="{
                'color-blue-dark': filter.data && filter.data.tickets && filter.data.tickets.unassigned === 0,
                'color-red-dark': filter.data && filter.data.tickets && filter.data.tickets.unassigned > 0
              }"
            >
              Требуют действий ({{ filter.data && filter.data.tickets && filter.data.tickets.unassigned }})
            </span>
          </div>
        </div>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="vertical-separate"></div>
      </div>
      <div class="grid__box grid__box--size-min">
        <span class="title">Смена</span>
      </div>
      <div class="grid__box grid__box--size-min" *ngIf="!loading">
        <a *ngIf="!filter.isCurrentDay" class="link link--dotted-blue-dark" (click)="filter.onSetCurrentDate()">Сегодня</a>
        <span *ngIf="filter.isCurrentDay" class="font-weight-bold color-blue-dark">Сегодня</span>
      </div>
      <div class="grid__box grid__box--size-min">
        <div class="field__datepicker field__datepicker--center" ngbDropdown>
          <div class="grid grid--va-middle grid--gap-8">
            <div class="grid__box grid__box--size-min pt-4">
              <button class="ctrl" type="button" id="appPreviewScheduleDate" (click)="filter.onWorkShiftPreviewDateChange()">
                <app-icon [glyph]="'arrow-left'" [size]="'12'" [color]="'gray-dark'"></app-icon>
              </button>
            </div>
            <div class="grid__box grid__box--size-min" style="width: 135px; text-align: center">
              <button class="ctrl link link--dotted-blue-dark" id="appOpenScheduleCalendar" ngbDropdownToggle>
                {{ filter.calendar.selectedDate | dateFormat: 'DD MMMM YYYY' }}
              </button>
            </div>
            <div class="grid__box grid__box--size-min pt-4">
              <button class="ctrl" type="button" id="appNextScheduleDate" (click)="filter.onWorkShiftNextDateChange()">
                <app-icon [glyph]="'arrow-right'" [size]="'12'" [color]="'gray-dark'"></app-icon>
              </button>
            </div>
          </div>
          <div ngbDropdownMenu class="datepicker-month" [hidden]="loading">
            <app-date-picker
              [startView]="'day'"
              [maxView]="'year'"
              [minView]="'day'"
              [(ngModel)]="filter.calendar.initDate"
              (change)="filter.onWorkShiftDateChange($event)">
            </app-date-picker>
            <div class="grid grid--gap-0 ml-8 mr-8 mb-8 pl-4 pr-4">
              <div class="grid__box grid__box--size-min">
                <span class="link link--dotted-gray-dark" (click)="filter.onSetCurrentDate()">Сейчас</span>
              </div>
              <div class="grid__box grid__box--size-min grid__box--pull-right">
                <span class="link link--dotted-gray-dark" ngbDropdownToggle>Закрыть</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="grid mt-16">
  <div class="grid__box grid__box--size-min grid__box--pull-right">
    <div class="grid grid--va-middle grid--gap-4">
      <div class="grid__box grid__box--size-min">
        <app-icon [glyph]="'update'" [size]="'16'" [class]="'icon--va-middle'" [color]="'gray-dark'"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">
        <a class="link link--dotted-blue-dark" (click)="filter.onUpdateWidget()">Обновить график</a>
      </div>
    </div>
  </div>
  <div class="grid__box grid__box--size-min ta-right">
    <a class="link link--dotted-gray" [ngbPopover]="LegendPopContent" placement="bottom-right" #p2="ngbPopover">Легенда</a>
  </div>
</div>

<ng-template #LegendPopContent>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--work-day"></div>
    </div>
    <div class="grid__box grid__box--size-min">Рабочий график сотрудника / Интервал заявки</div>
  </div>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--work-time"></div>
    </div>
    <div class="grid__box grid__box--size-min">Рабочее время / В работе</div>
  </div>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--lunch-time"></div>
    </div>
    <div class="grid__box grid__box--size-min">Перерыв</div>
  </div>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--moved-time"></div>
    </div>
    <div class="grid__box grid__box--size-min">В пути</div>
  </div>
  <div class="grid grid--va-middle grid--gap-8 mt-2 mb-2">
    <div class="grid__box grid__box--size-min">
      <div class="interval-square interval-square--expiration-time"></div>
    </div>
    <div class="grid__box grid__box--size-min">Просрочено / Требуют действий</div>
  </div>
</ng-template>
